"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const BestRecommendation_vue_1 = __importDefault(require("./BestRecommendation.vue"));
const FieldsRecommendations_vue_1 = __importDefault(require("./FieldsRecommendations.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const lucide_vue_next_1 = require("lucide-vue-next");
let RecommendationsActionsPanel = class RecommendationsActionsPanel extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.activeRecommendation = new Recommendations_1.AgInputRecommendationCategory({}, {});
        this.filteredFields = [...this.fields];
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    emitFieldNamePreSelect(name) {
        this.$emit('fieldNamePreSelect', name);
    }
    updateActiveRecommendation(p) {
        this.activeRecommendation = p;
        this.updateFilteredFields();
    }
    updateFilteredFields() {
        if (this.activeRecommendation) {
            this.filteredFields = this.fields
                .filter((f) => f.recSet.isAgInputRecommended(this.activeRecommendation.slug))
                .map((fi) => fi);
            this.filteredFields
                .sort((a, b) => {
                var _a, _b, _c, _d;
                if (((_a = b.recSet.curatedRecommendations[0]) === null || _a === void 0 ? void 0 : _a.level) !== ((_b = a.recSet.curatedRecommendations[0]) === null || _b === void 0 ? void 0 : _b.level)) {
                    return ((_c = b.recSet.curatedRecommendations[0]) === null || _c === void 0 ? void 0 : _c.level) - ((_d = a.recSet.curatedRecommendations[0]) === null || _d === void 0 ? void 0 : _d.level);
                }
                else {
                    if (a.name.length !== b.name.length) {
                        return a.name.length - b.name.length;
                    }
                    else {
                        if (a.name < b.name) {
                            return -1;
                        }
                        else if (a.name > b.name) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    }
                }
            });
        }
    }
    dismissRecommendations() {
        this.$emit('dismissRecommendations');
    }
    updateFields() {
        this.updateFilteredFields();
    }
    mounted() {
        var _a;
        this.activeRecommendation = (_a = this.recommendationSet) === null || _a === void 0 ? void 0 : _a.topAgInputsByCategory[0];
        this.updateFilteredFields();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], RecommendationsActionsPanel.prototype, "recommendationSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], RecommendationsActionsPanel.prototype, "fields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], RecommendationsActionsPanel.prototype, "gisFields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], RecommendationsActionsPanel.prototype, "needMap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new project_1.AreaProjectDeliverable({}) })
], RecommendationsActionsPanel.prototype, "projectSelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], RecommendationsActionsPanel.prototype, "showFieldsBreakdown", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], RecommendationsActionsPanel.prototype, "hideHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], RecommendationsActionsPanel.prototype, "hasInteraction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], RecommendationsActionsPanel.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], RecommendationsActionsPanel.prototype, "dismissable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], RecommendationsActionsPanel.prototype, "setFieldNamePreSelect", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], RecommendationsActionsPanel.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fields')
], RecommendationsActionsPanel.prototype, "updateFields", null);
RecommendationsActionsPanel = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BestRecommendation: BestRecommendation_vue_1.default,
            FieldsRecommendations: FieldsRecommendations_vue_1.default,
            Separator: bmk_ui_framework_1.Separator,
            Button: bmk_ui_framework_1.Button,
            X: lucide_vue_next_1.X
        },
    })
], RecommendationsActionsPanel);
exports.default = RecommendationsActionsPanel;
